import { SvgAttribute } from "@/shared/constants/constants";

export const COMPONENT_NAME = "kyc-documents";

export const SVG: SvgAttribute = {
  camera: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 8.5h3l1.2-2h7.6l1.2 2h3v10.2A1.3 1.3 0 0 1 18.7 20H5.3A1.3 1.3 0 0 1 4 18.7V8.5Z"/>
    <circle cx="12" cy="14" r="3.2"/>
  </svg>`,
  arrow: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h13M14 7l5 5-5 5"/></svg>`,
};
